// Key naming format: BG/ICON/IMG/LOGO_{page/component}
const AssetKeys = {
	// Backgrounds
	BG_LOGIN: 'bgLogin',
	BG_HOME: 'bgHome',
	BG_MAIN: 'bgMain',
	BG_CHAT: 'bgChat',
	BG_SYSTEM: 'bgSystem',

	// Backgrounds (mobile)
	BG_LOGIN_MOBILE: 'bgLoginMobile',
	BG_HOME_MOBILE: 'bgHomeMobile',
	BG_MAIN_MOBILE: 'bgMainMobile',
	BG_CHAT_MOBILE: 'bgChatMobile',
	BG_SYSTEM_MOBILE: 'bgSystemMobile',

	// Illustrations
	IMG_404: 'img404',
	IMG_CHAT_OVER: 'imgChatOver',
	IMG_MAINTAIN: 'imgMaintain',
	IMG_LOADING: 'imgLoading',

	// Optional UI textures
	TEXTURE_GRID: 'textureGrid',
	TEXTURE_NOISE: 'textureNoise',

	// Icon set / sprite（若未來不同 theme 要切 icon 組）
	ICON_SET: 'iconSet',

	// Input bar
	ICON_UPLOAD_FILE: 'iconUploadFile',
	ICON_CONTEXT_FONT_SIZE_BTN: 'iconContextFontSizeBtn',
	ICON_DISABLED_CONTEXT_FONT_SIZE_BTN: 'iconDisabledContextFontSizeBtn',
	ICON_EMOJI_PICKER: 'iconEmojiPicker',
	ICON_DISABLED_EMOJI_PICKER: 'iconDisabledEmojiPicker',
	ICON_FILE: 'iconFile',
	ICON_REMOVE_UPLOAD_FILE_BTN: 'iconRemoveUploadFileBtn',
	ICON_SCREENSHOT_BTN: 'iconScreenshotBtn',
	ICON_DISABLED_SCREENSHOT_BTN: 'iconDisabledScreenshotBtn',
	ICON_SUBMIT_BTN: 'iconSubmitBtn',
	ICON_DISABLED_SUBMIT_BTN: 'iconDisabledSubmitBtn',
	ICON_CANT_SEND_SUBMIT_BTN: 'iconCantSendSubmitBtn',
	ICON_UPLOAD_FILE_BTN: 'iconUploadFileBtn',
	ICON_DISABLED_UPLOAD_FILE_BTN: 'iconDisabledUploadFileBtn',
	ICON_VIDEO_PLAY_BTN: 'iconVideoPlayBtn',
	ICON_EXTEND_BTN: 'iconExtendBtn',

	// Icons
	ICON_LOGO: 'iconLogo',
	ICON_LONG_LOGO: 'iconLongLogo',
	ICON_LOGIN: 'iconLogin',
	ICON_LOGOUT: 'iconLogout',
	ICON_CLIENT_ENTRIES_NORMAL_REPLY: 'iconClientEntriesNormalReply',
	ICON_CLIENT_ENTRIES_QUICK_PATH: 'iconClientEntriesQuickPath',
	ICON_CLIENT_ENTRIES_SMART_REPLY: 'iconClientEntriesSmartReply',
	ICON_CLIENT_ENTRIES_ARTICLE_EXPAND: 'iconClientEntriesArticleExpand',
	ICON_LANGUAGE: 'iconLanguage',

	// Dialog
	ICON_DIALOG_FILE: 'iconDialogFile',
	ICON_ALERT: 'iconAlert',
	ICON_PLAY: 'iconPlay',
	ICON_DOWNLOAD: 'iconDownload',
	ICON_PLAY_FILL: 'iconPlayFill',
	ICON_ANSWERING: 'iconAnswering',
	ICON_PURPLE_COPY: 'iconPurpleCopy',
	ICON_UPLOAD: 'iconUpload',
	ICON_ARROW_DOWN: 'iconArrowDown',
	ICON_ARROW_UP: 'iconArrowUp',
	ICON_ARROW_LEFT: 'iconArrowLeft',
	ICON_ARROW_RIGHT: 'iconArrowRight',
	ICON_PURPLE_EDIT: 'iconPurpleEdit',
	ICON_BLACK_QUOTE: 'iconBlackQuote',
	ICON_BLACK_COPY: 'iconBlackCopy',
	ICON_IMAGE: 'iconImage',
};
const ALL_ASSET_KEYS = Object.values(AssetKeys);

function isValidAssetKey(key) {
	return ALL_ASSET_KEYS.includes(key);
}

export {
	AssetKeys,
	ALL_ASSET_KEYS,
	isValidAssetKey,
};
